module.exports = __webpack_public_path__ + "images/a8d1816583d783024cb0d92ebc2d711b-level5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/level5.png
// module id = 1028
// module chunks = 0